import React, { useState } from "react";
import MaintenanceLayout from "../shared/MaintenanceLayout";
import ZitadelFlowFull from "./ZitadelFlowFull";
import ZitadelFlowZitadelLink from "./ZitadelFlowZitadelLink";
import ZitadelFlowLinkOnly from "./ZitadelFlowLinkOnly";
import ZitadelFlowManageGrants from "./ZitadelFlowManageGrants";
import ZitadelManageUsers from "./ZitadelManageUsers";
import "./zitadel-provisioning.scss";

type FlowKey = "full" | "zlink" | "link" | "grants" | "users";

const FLOWS: { key: FlowKey; label: string; hint: string }[] = [
  {
    key: "full",
    label: "Full onboarding",
    hint: "Create org_custom → Zitadel org → grant → users → link",
  },
  {
    key: "zlink",
    label: "Zitadel + link",
    hint: "org_custom exists → create Zitadel org → grant → users → link",
  },
  {
    key: "link",
    label: "Link only",
    hint: "Both exist → just set zitadel_tenant_id",
  },
  {
    key: "grants",
    label: "Manage grants",
    hint: "Change an org's project-grant role keys",
  },
  {
    key: "users",
    label: "Manage users",
    hint: "Add / deactivate / reactivate / roles",
  },
];

const ZitadelProvisioning: React.FC = () => {
  const [flow, setFlow] = useState<FlowKey>("full");

  return (
    <MaintenanceLayout title="Zitadel Provisioning">
      <div className="maint-stations">
        <div className="ztl-tabs">
          {FLOWS.map((f) => (
            <button
              key={f.key}
              className={flow === f.key ? "active" : ""}
              onClick={() => setFlow(f.key)}
              title={f.hint}
            >
              {f.label}
            </button>
          ))}
        </div>

        <p className="ztl-summary" style={{ marginBottom: 16, color: "#888" }}>
          {FLOWS.find((f) => f.key === flow)?.hint}
        </p>

        {flow === "full" && <ZitadelFlowFull />}
        {flow === "zlink" && <ZitadelFlowZitadelLink />}
        {flow === "link" && <ZitadelFlowLinkOnly />}
        {flow === "grants" && <ZitadelFlowManageGrants />}
        {flow === "users" && <ZitadelManageUsers />}
      </div>
    </MaintenanceLayout>
  );
};

export default ZitadelProvisioning;
